module.exports = __webpack_public_path__ + "img/4-clicks.2de91ddd.svg";